var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.874196 0.882399C1.11387 0.637549 1.43888 0.5 1.77778 0.5C2.11667 0.5 2.44169 0.637549 2.68136 0.882399L9.00772 7.34743L15.3341 0.882399C15.5751 0.644488 15.898 0.512844 16.2331 0.515819C16.5682 0.518795 16.8887 0.656153 17.1257 0.898309C17.3626 1.14046 17.497 1.46804 17.5 1.81049C17.5029 2.15294 17.374 2.48285 17.1412 2.72918L9.9113 10.1176C9.67163 10.3625 9.34661 10.5 9.00772 10.5C8.66882 10.5 8.3438 10.3625 8.10413 10.1176L0.874196 2.72918C0.634599 2.48425 0.5 2.15211 0.5 1.80579C0.5 1.45947 0.634599 1.12732 0.874196 0.882399Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown2);
export default __webpack_public_path__ + "static/media/arrowDown2.79a9e37fa76d8ade8274886043849348.svg";
export { ForwardRef as ReactComponent };